let gMapsgMapsUtilService = {};

let map = "";
let marker = [];

const _initMap = function (lat, long) {
  const location = new google.maps.LatLng(lat, long); // Replace the location (Latitude, Longitude). It will get from here 'http://www.gps-coordinates.net/'.
  const mapCanvas = document.getElementById('map');
  const styles = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#444444"}]
  }, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{"color": "#f2f2f2"}]
  }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{"visibility": "off"}]
  }, {
    "featureType": "poi.medical",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#dddddd"}, {"visibility": "on"}]
  }, {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#c3e0b6"}, {"visibility": "on"}]
  }, {
    "featureType": "poi.school",
    "elementType": "geometry.fill",
    "stylers": [{"visibility": "on"}, {"color": "#dfdfdf"}]
  }, {
    "featureType": "poi.sports_complex",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#d5d5d5"}, {"weight": "1.16"}, {"visibility": "on"}]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"lightness": 45}]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
  }, {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#d0d9ea"}, {"lightness": "17"}]
  }, {
    "featureType": "road.arterial",
    "elementType": "geometry.stroke",
    "stylers": [{"visibility": "off"}]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
  }, {
    "featureType": "road.local",
    "elementType": "geometry.stroke",
    "stylers": [{"visibility": "off"}]
  }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{"visibility": "off"}]
  }, {
    "featureType": "transit.station.airport",
    "elementType": "geometry.fill",
    "stylers": [{"visibility": "on"}, {"lightness": "32"}]
  }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{"color": "#52c6f5"}, {"visibility": "on"}]
  }];
  const styledMap = new google.maps.StyledMapType(styles, {name: "MarQ."});
  const mapOptions = {
    center: location,
    minZoom: 5,
    zoom: 12,  // Up to 22
    panControl: false,
    scrollwheel: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    streetViewControl: false,
    mapTypeControlOptions: {
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
    }
  };

  map = new google.maps.Map(mapCanvas, mapOptions);
  map.mapTypes.set('map_style', styledMap);
  map.setMapTypeId('map_style');

  // Get more custom Google Map background design in here 'https://snazzymaps.com/'.
  // map.set('styles', styles);
};

let _addMarker = function (lat, lng) {
  let location = new google.maps.LatLng(lat, lng);
  marker = new google.maps.Marker({
    position: location,
    map: map
  });
};

gMapsgMapsUtilService.initMap = _initMap;
gMapsgMapsUtilService.addMarker = _addMarker;

export const GMAPS_UTIL_SERVICE = gMapsgMapsUtilService;



// WEBPACK FOOTER //
// ./src/gMapsUtils.js